import { Text, Field, Placeholder, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import withValidDatasourceCheck from 'lib/enhancers/withValidDatasourceCheck';

import type { ComponentProps } from 'lib/component-props';

import styles from './DynamicDropdown.module.scss';
import { CustomInfo } from 'models/custom-resolver-types';

type DropdownOptionsFields = {
  label: Field<string>;
};

export type DropdownOptionsProps = ComponentProps & {
  fields: CustomInfo & DropdownOptionsFields;
};

const cx = classNames.bind(styles);

const DropdownOption = (props: DropdownOptionsProps): React.JSX.Element => {
  const { rendering } = props;
  const { uid } = rendering;

  const { sitecoreContext } = useSitecoreContext();
  const { pageEditing } = sitecoreContext;

  if (pageEditing) {
    return (
      <div className={cx({ option: true, 'page-editing': pageEditing })} id={`tabpanel-${uid}`}>
        <div className={cx('watermark')}>
          <Text field={props.fields.label} />
        </div>
        <Placeholder key={uid} name="hp-dropdown" rendering={rendering} disableSuspense={true} />
      </div>
    );
  } else {
    return (
      <div className={cx({ option: true, 'page-editing': pageEditing })} id={`tabpanel-${uid}`}>
        <Placeholder key={uid} name="hp-dropdown" rendering={rendering} disableSuspense={true} />
      </div>
    );
  }
};

export default withValidDatasourceCheck()<DropdownOptionsProps>(DropdownOption);
